import React from 'react'
import { Link } from 'react-router-dom'
import { StyledHeader, LogoContainer } from './HomeHeader.styled'
import { DualLogos } from '@the-game/components/GlobalHeader/GlobalHeader'

function HomeHeader() {
    return (
        <StyledHeader>
            <LogoContainer>
                <DualLogos
                    showOfficialSponsor
                    homeLink={({ children }) => <Link to="/">{children}</Link>}
                />
            </LogoContainer>
        </StyledHeader>
    )
}

export default HomeHeader
